<template>
    <div>

        <b-modal
        class="main-modal"
        ref="showEnterSuccessModal"
        size="lg"
        ok-only
        ok-title="Done"
        >
            <div class="d-block">

                <div class="row">
                    <div class="col-md-12 text-center">
                        <img src="@/assets/images/main/sleep-outfitters-logo.png" style="max-width: 280px; padding-bottom: 30px;" class="header-image img-fluid" alt="Tempur-Pedic">
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 text-center">
                        <div class="icon-block text-center" style="font-size:40px;">
                            <font-awesome-icon :icon="['fal', 'check-circle']" class="fa fa-fw" />
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <p class="text-content text-center">Thank you for your review! <br> You are entered for a chance to win a free Tempur-Pedic mattress set!*</p>
                    </div>
                </div>

            </div>
        </b-modal>

    </div>
</template>

<script>
export default {
    name: 'enter-success-modal',
    data () {
        return {
        }
    },
    methods: {
        //
        // Modals
        //
        showEnterSuccessModal () {
            this.$refs.showEnterSuccessModal.show()
        }
    },
    mounted () {
        // Register Modals
        this.$root.$on('showEnterSuccessModal', () => { this.showEnterSuccessModal() })
    },
    computed: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/app.scss';
</style>
